import { filtroNumeroDocumento } from './numero-documento';

describe('filtroNumeroDocumento', () => {
  it('número completo → filtro exacto por establecimiento, punto y número', () => {
    expect(filtroNumeroDocumento('001-002-0000552')).toEqual({ dest: '001', dpunexp: '002', dnumdoc: '0000552' });
    expect(filtroNumeroDocumento('  001-002-0000552 ')).toEqual({ dest: '001', dpunexp: '002', dnumdoc: '0000552' });
  });

  it('partes sin ceros a la izquierda se completan', () => {
    expect(filtroNumeroDocumento('1-2-552')).toEqual({ dest: '001', dpunexp: '002', dnumdoc: '0000552' });
  });

  it('cualquier otro texto no es un número de documento', () => {
    expect(filtroNumeroDocumento('0000552')).toBeNull();
    expect(filtroNumeroDocumento('Juan Pérez')).toBeNull();
    expect(filtroNumeroDocumento('001-002')).toBeNull();
    expect(filtroNumeroDocumento('')).toBeNull();
  });
});
